import React, { useCallback } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import menuStyles from './styles';

type Props = {
  value: boolean;
  title: string;
  shortcut: string;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  open?: boolean;
}; 

const ToggleMenuItem = (props: Props) => {
  const classes = menuStyles();

  const {
    value,
    title,
    shortcut,
    onChange,
    disabled,
    open,
  } = props;

  const toggle = useCallback(() => {
    !disabled && onChange(!value);
  }, [disabled, onChange, value]);

  useHotkeys(shortcut, toggle, { keydown: true, keyup: false }, [toggle]);

  return open ? (
    <div className={disabled ? classes.disabledItem : classes.menuItem} onMouseUp={toggle}>
      <div className={classes.preTitle}>{ value && '✓' }</div>
      <div className={classes.title}>{ title }</div>
      <div className={classes.shortcutText}>{ shortcut }</div>
    </div>
  ) : <></>;
};

export default ToggleMenuItem;